// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { useState, useContext } from 'react';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';

import BottomNavigation from 'presentations/views/components/atoms/BottomNavigation';
import Icon from 'presentations/views/components/atoms/Icon';
import {
  accountSettingLoginPath,
  accountSettingPath,
  accountSettingProfilePath,
  adminSettingPath,
  adminUserListPath,
  calendarIntegrationsPath,
  calendarIntegrationsNewPath,
  dashboardCalendarsPath,
  dashboardPath,
  dashboardTodayPath,
  hostEventTypeSettingPath,
  integrationListPath,
  scheduledEventListPath,
  dashboardStatsPath,
} from 'presentations/routes/path';
import { gray01 } from 'presentations/views/styles/color';
// import { DashboardCalendarContext } from 'presentations/reducers/DashboardCalendar';

function getValue(path: string) {
  if (path.startsWith(dashboardCalendarsPath())) {
    return 1;
  } else if (
    path.startsWith(accountSettingPath()) ||
    path.startsWith(accountSettingProfilePath()) ||
    path.startsWith(accountSettingLoginPath()) ||
    path.startsWith(adminSettingPath()) ||
    path.startsWith(adminUserListPath()) ||
    path.startsWith(hostEventTypeSettingPath()) ||
    path === calendarIntegrationsPath() ||
    path === calendarIntegrationsNewPath() ||
    path === integrationListPath()
  ) {
    return 2;
  } else if (
    path === dashboardPath() ||
    path.startsWith(dashboardPath({ user: '' })) ||
    path.startsWith(scheduledEventListPath()) ||
    path.startsWith(dashboardTodayPath())
  ) {
    return 0;
  }

  return -1;
}

export default function Component() {
  const t = translateInComponent(translations);
  // const { state, dispatch } = useContext(DashboardCalendarContext);

  const router = useRouter();

  const [value, setValue] = useState<number>(getValue(router.asPath));

  const onChange = (event: any, newValue: number) => {
    setValue(newValue);

    switch (newValue) {
      case 0:
        router.push(dashboardPath());
        break;
      case 1:
        if (value === newValue) {
          router.replace(dashboardCalendarsPath());
        } else {
          router.push(dashboardCalendarsPath());
        }
        break;
      case 2:
        router.push(dashboardStatsPath());
        break;
      case 3:
        router.push(accountSettingPath());
        break;
    }
  };

  return (
    <BottomNavigation
      value={value}
      onChange={onChange}
      items={[
        {
          label: t('Dashboard'),
          icon: <DashboardIcon name="home" />,
        },
        {
          label: t('Calendar'),
          icon: <DashboardIcon name="calendar-month" />,
        },
        {
          label: t('Analytics'),
          icon: <DashboardIcon name="chart-bar" />,
        },
        {
          label: t('Settings'),
          icon: <DashboardIcon name="settings" />,
        },
      ]}
    />
  );
}

const DashboardIcon = styled(Icon)`
  width: 24px !important;
  height: 24px !important;
`;
